// extracted by mini-css-extract-plugin
export default {"tube":"Header_tube__g3eRd"};